import styled, { CSSProperties } from 'styled-components';

import { BodilFont } from '~src/branding';

export const TooltipWrapper = styled.div<{
  fontStyle?: CSSProperties;
}>(({ fontStyle = BodilFont.style('heading', 14) }) => ({
  ...fontStyle,
  color: 'black',
  padding: '1px',
  textAlign: 'left',
  background: 'transparent',
}));

export const TooltipItem = styled.div<{ background?: string; color?: string }>(
  ({ color = 'black', background = 'white' }) => ({
    borderRadius: '10px',
    marginTop: '8px',
    padding: '0 8px',
    background: background,
    color,
  })
);
